
<app-loading-page></app-loading-page>

<div id="gestione-utenti">

  <div id="pagecontent" *ngIf="isLoadingStaticData === false">

    <br>

    <div class="container-fluid">

      <div class="row">
<!--        <div class="col-md-1"></div>-->
        <div class="col-md-3">
          <h4>Selezione utente</h4>
          <div *ngIf="isLoading !== true && isFirsttime !== true">
            <div *ngIf="recordChanged" style="display: flex; align-items: center;">
              <h5 style="margin: 10px;">Attenzione, record variati --> </h5>
              <button mat-raised-button color="primary" (click)="RefreshPageData()">RILEGGI</button>
            </div>

            <table mat-table [dataSource]="uniqueUserNames" class="mat-elevation-z8">

              <!-- Utente -->
              <ng-container matColumnDef="utente">
                <th mat-header-cell *matHeaderCellDef>Utente</th>
                <td mat-cell *matCellDef="let item; let i = index">
                  <button mat-button color="accent" (click)="ShowDetails(item, i)" [class.button-active]="detailActiveButton === i">
                    {{ item }}
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="['utente']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['utente'];"></tr>
            </table>
          </div>
        </div>

  <!--      <div class="col-md-1"></div>-->

        <div class="col-md-8">
          <div *ngIf="!isLoading && !isFirsttime && isDetailVisible" class="table-container">
            <h4>Autorizzazione ai menu</h4>

            <table mat-table [dataSource]="detailMenuAccessPermission" class="mat-elevation-z8">
              <!-- Menu -->
              <ng-container matColumnDef="menu">
                <th mat-header-cell *matHeaderCellDef>Menu</th>
                <td mat-cell *matCellDef="let item">{{ item.functionName }}</td>
              </ng-container>

              <!-- Autorizzato -->
              <ng-container matColumnDef="autorizzato">
                <th mat-header-cell *matHeaderCellDef class="text-center">
                  Autorizzato
                  <div>
                    <mat-checkbox
                      (change)="masterToggle($event, detailMenuAccessPermission, CheckMenuNeedToBeSaved.bind(this), 'read')"
                      [checked]="areAllSelected(detailMenuAccessPermission, 'read')"
                      [indeterminate]="areSomeSelected(detailMenuAccessPermission, 'read') && !areAllSelected(detailMenuAccessPermission, 'read')">
                    </mat-checkbox>
                  </div>
                </th>
                <td mat-cell *matCellDef="let item; let i = index" class="text-center">
                  <mat-checkbox [(ngModel)]="item.read" (change)="item.isRowChanged = CheckMenuNeedToBeSaved(i)"></mat-checkbox>
                </td>
              </ng-container>

              <!-- Salva -->
              <ng-container matColumnDef="salva">
                <th mat-header-cell *matHeaderCellDef class="text-center">Salva</th>
                <td mat-cell *matCellDef="let item; let i = index" class="text-center">
                  <button mat-raised-button background-color="lawngreen" [disabled]="!item.isRowChanged" (click)="SaveMenuRowChange(item, i)">
                    Salva
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="['menu', 'autorizzato', 'salva']; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: ['menu', 'autorizzato', 'salva'];"></tr>
            </table>
          </div>

          <div *ngIf="!isLoading && !isFirsttime && isDetailVisible" class="table-container">
            <h4>Autorizzazione alle funzioni di menu</h4>

            <table mat-table [dataSource]="detailFunctionAccessPermission" class="mat-elevation-z8">
              <!-- Funzione di Menu -->
              <ng-container matColumnDef="function">
                <th mat-header-cell *matHeaderCellDef>Funzione di Menu</th>
                <td mat-cell *matCellDef="let item">{{ item.functionName }}</td>
              </ng-container>

              <!-- Modifica -->
              <ng-container matColumnDef="modifica">
                <th mat-header-cell *matHeaderCellDef class="text-center">
                  Modifica
                  <div>
                    <mat-checkbox
                      (change)="masterToggle($event, detailFunctionAccessPermission, CheckFunctionNeedToBeSaved.bind(this), 'change')"
                      [checked]="areAllSelected(detailFunctionAccessPermission, 'change')"
                      [indeterminate]="areSomeSelected(detailFunctionAccessPermission, 'change') && !areAllSelected(detailFunctionAccessPermission, 'change')">
                    </mat-checkbox>
                  </div>
                </th>
                <td mat-cell *matCellDef="let item; let i = index" class="text-center">
                  <mat-checkbox [(ngModel)]="item.change" (change)="item.isRowChanged = CheckFunctionNeedToBeSaved(i)"></mat-checkbox>
                </td>
              </ng-container>

              <!-- Lettura -->
              <ng-container matColumnDef="lettura">
                <th mat-header-cell *matHeaderCellDef class="text-center">
                  Lettura
                  <div>
                    <mat-checkbox
                      (change)="masterToggle($event, detailFunctionAccessPermission, CheckFunctionNeedToBeSaved.bind(this), 'read')"
                      [checked]="areAllSelected(detailFunctionAccessPermission, 'read')"
                      [indeterminate]="areSomeSelected(detailFunctionAccessPermission, 'read') && !areAllSelected(detailFunctionAccessPermission, 'read')">
                    </mat-checkbox>
                  </div>
                </th>
                <td mat-cell *matCellDef="let item; let i = index" class="text-center">
                  <mat-checkbox [(ngModel)]="item.read" (change)="item.isRowChanged = CheckFunctionNeedToBeSaved(i)"></mat-checkbox>
                </td>
              </ng-container>

              <!-- Aggiornamento -->
              <ng-container matColumnDef="aggiornamento">
                <th mat-header-cell *matHeaderCellDef class="text-center">
                  Aggiornamento
                  <div>
                    <mat-checkbox
                      (change)="masterToggle($event, detailFunctionAccessPermission, CheckFunctionNeedToBeSaved.bind(this), 'update')"
                      [checked]="areAllSelected(detailFunctionAccessPermission, 'update')"
                      [indeterminate]="areSomeSelected(detailFunctionAccessPermission, 'update') && !areAllSelected(detailFunctionAccessPermission, 'update')">
                    </mat-checkbox>
                  </div>
                </th>
                <td mat-cell *matCellDef="let item; let i = index" class="text-center">
                  <mat-checkbox [(ngModel)]="item.update" (change)="item.isRowChanged = CheckFunctionNeedToBeSaved(i)"></mat-checkbox>
                </td>
              </ng-container>

              <!-- Eliminazione -->
              <ng-container matColumnDef="eliminazione">
                <th mat-header-cell *matHeaderCellDef class="text-center">
                  Eliminazione
                  <div>
                    <mat-checkbox
                      (change)="masterToggle($event, detailFunctionAccessPermission, CheckFunctionNeedToBeSaved.bind(this), 'delete')"
                      [checked]="areAllSelected(detailFunctionAccessPermission, 'delete')"
                      [indeterminate]="areSomeSelected(detailFunctionAccessPermission, 'delete') && !areAllSelected(detailFunctionAccessPermission, 'delete')">
                    </mat-checkbox>
                  </div>
                </th>
                <td mat-cell *matCellDef="let item; let i = index" class="text-center">
                  <mat-checkbox [(ngModel)]="item.delete" (change)="item.isRowChanged = CheckFunctionNeedToBeSaved(i)"></mat-checkbox>
                </td>
              </ng-container>

              <!-- Salva -->
              <ng-container matColumnDef="salva">
                <th mat-header-cell *matHeaderCellDef class="text-center">Salva</th>
                <td mat-cell *matCellDef="let item; let i = index" class="text-center">
                  <button mat-raised-button color="primary" [disabled]="!item.isRowChanged" (click)="SaveFunctionRowChange(item, i)">
                    Salva
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="['function', 'modifica', 'lettura', 'aggiornamento', 'eliminazione', 'salva']; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: ['function', 'modifica', 'lettura', 'aggiornamento', 'eliminazione', 'salva'];"></tr>
            </table>
          </div>

          <div *ngIf="!isLoading && !isFirsttime && isDetailVisible" class="table-container">
            <h4>Autorizzazione di accesso alle WEB API</h4>

            <table mat-table [dataSource]="detailWebapiAccessPermission" class="mat-elevation-z8">
              <!-- Accesso a WEB API -->
              <ng-container matColumnDef="function">
                <th mat-header-cell *matHeaderCellDef>Accesso a WEB API</th>
                <td mat-cell *matCellDef="let item">{{ item.functionName }}</td>
              </ng-container>

              <!-- POST -->
              <ng-container matColumnDef="post">
                <th mat-header-cell *matHeaderCellDef class="text-center">
                  [POST]
                  <div>
                    <mat-checkbox
                      (change)="masterToggle($event, detailWebapiAccessPermission, CheckWebapiNeedToBeSaved.bind(this), 'change')"
                      [checked]="areAllSelected(detailWebapiAccessPermission, 'change')"
                      [indeterminate]="areSomeSelected(detailWebapiAccessPermission, 'change') && !areAllSelected(detailWebapiAccessPermission, 'change')">
                    </mat-checkbox>
                  </div>
                </th>
                <td mat-cell *matCellDef="let item; let i = index" class="text-center">
                  <mat-checkbox [(ngModel)]="item.change" (change)="item.isRowChanged = CheckWebapiNeedToBeSaved(i)"></mat-checkbox>
                </td>
              </ng-container>

              <!-- GET -->
              <ng-container matColumnDef="get">
                <th mat-header-cell *matHeaderCellDef class="text-center">
                  [GET]
                  <div>
                    <mat-checkbox
                      (change)="masterToggle($event, detailWebapiAccessPermission, CheckWebapiNeedToBeSaved.bind(this), 'read')"
                      [checked]="areAllSelected(detailWebapiAccessPermission, 'read')"
                      [indeterminate]="areSomeSelected(detailWebapiAccessPermission, 'read') && !areAllSelected(detailWebapiAccessPermission, 'read')">
                    </mat-checkbox>
                  </div>
                </th>
                <td mat-cell *matCellDef="let item; let i = index" class="text-center">
                  <mat-checkbox [(ngModel)]="item.read" (change)="item.isRowChanged = CheckWebapiNeedToBeSaved(i)"></mat-checkbox>
                </td>
              </ng-container>

              <!-- PUT -->
              <ng-container matColumnDef="put">
                <th mat-header-cell *matHeaderCellDef class="text-center">
                  [PUT]
                  <div>
                    <mat-checkbox
                      (change)="masterToggle($event, detailWebapiAccessPermission, CheckWebapiNeedToBeSaved.bind(this), 'update')"
                      [checked]="areAllSelected(detailWebapiAccessPermission, 'update')"
                      [indeterminate]="areSomeSelected(detailWebapiAccessPermission, 'update') && !areAllSelected(detailWebapiAccessPermission, 'update')">
                    </mat-checkbox>
                  </div>
                </th>
                <td mat-cell *matCellDef="let item; let i = index" class="text-center">
                  <mat-checkbox [(ngModel)]="item.update" (change)="item.isRowChanged = CheckWebapiNeedToBeSaved(i)"></mat-checkbox>
                </td>
              </ng-container>

              <!-- DELETE -->
              <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef class="text-center">
                  [DELETE]
                  <div>
                    <mat-checkbox
                      (change)="masterToggle($event, detailWebapiAccessPermission, CheckWebapiNeedToBeSaved.bind(this), 'delete')"
                      [checked]="areAllSelected(detailWebapiAccessPermission, 'delete')"
                      [indeterminate]="areSomeSelected(detailWebapiAccessPermission, 'delete') && !areAllSelected(detailWebapiAccessPermission, 'delete')">
                    </mat-checkbox>
                  </div>
                </th>
                <td mat-cell *matCellDef="let item; let i = index" class="text-center">
                  <mat-checkbox [(ngModel)]="item.delete" (change)="item.isRowChanged = CheckWebapiNeedToBeSaved(i)"></mat-checkbox>
                </td>
              </ng-container>

              <!-- Salva -->
              <ng-container matColumnDef="salva">
                <th mat-header-cell *matHeaderCellDef class="text-center">Salva</th>
                <td mat-cell *matCellDef="let item; let i = index" class="text-center">
                  <button mat-raised-button color="primary" [disabled]="!item.isRowChanged" (click)="SaveWebapiRowChange(item, i)">
                    Salva
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="['function', 'post', 'get', 'put', 'delete', 'salva']; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: ['function', 'post', 'get', 'put', 'delete', 'salva'];"></tr>
            </table>
          </div>
        </div>

        </div>
      </div>
    </div>

</div>

